// @flow

import React, { type Node } from 'react';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import { IfFeature, type Feature } from '@tectonics/prs/feature';

import {
  FieldBrazilianDocument,
  FieldChileanDocument,
  FieldColombianDocument,
  FieldCustomerEmail,
  FieldCustomerName,
  FieldCustomerPhoneNumber,
  FieldPeruvianDocument,
  FieldArgentineDocument,
} from './fields';

import { VrDisplayName, VrPreTokenizedCardCvv } from './vr';

export function CustomerFields(): Node {
  const allFeatures = useCurrentAllFeatures();

  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="display_vr_display_name">
        <VrDisplayName />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_vr_pre_tokenized_card_cvv">
        <VrPreTokenizedCardCvv />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_customer_name">
        <FieldCustomerName />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <FieldCustomerDocument allFeatures={allFeatures} />
      <FieldPhoneNumber allFeatures={allFeatures} />
    </>
  );
}

type FieldProps = {
  allFeatures: ImmutableArray<Feature>,
};

function FieldPhoneNumber({ allFeatures }: FieldProps): Node {
  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="field_peruvian_phone_number">
        <FieldCustomerPhoneNumber inputFieldName="peruvianPhoneNumber" />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_phone_number">
        <FieldCustomerPhoneNumber inputFieldName="argentinePhoneNumber" />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_phone_number">
        <FieldCustomerPhoneNumber inputFieldName="colombianPhoneNumber" />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_ecuadorian_phone_number">
        <FieldCustomerPhoneNumber inputFieldName="ecuadorianPhoneNumber" />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_phone_number">
        <FieldCustomerPhoneNumber inputFieldName="chileanPhoneNumber" />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_mexican_phone_number">
        <FieldCustomerPhoneNumber inputFieldName="mexicanPhoneNumber" />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_bolivian_phone_number">
        <FieldCustomerPhoneNumber inputFieldName="bolivianPhoneNumber" />
      </IfFeature>
    </>
  );
}

function FieldCustomerDocument({ allFeatures }: FieldProps): Node {
  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="field_brazilian_document">
        <FieldBrazilianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_document">
        <FieldColombianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_document">
        <FieldChileanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_peruvian_document">
        <FieldPeruvianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_document">
        <FieldArgentineDocument />
      </IfFeature>
    </>
  );
}
